/**
 * Sysadmin Fine-Tuning → index redirect.
 *
 * Lands every /sysadmin/fine-tuning visit on the Adapters sub-tab —
 * matches the established sysadmin rail pattern (audit, governance,
 * etc).
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/fine-tuning/')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/fine-tuning/adapters' });
  },
});
